module.exports = __webpack_public_path__ + "img/qr2.26fbabf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/qr2.png
// module id = tvlC
// module chunks = 57